import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import axios from "axios";
import BASEURL from "../../Config/global";
import { setAccessToken } from "../../Util/authHeader";

import { useDispatch, useSelector } from "react-redux";
import { setUserDetails } from "../../Store/Slices/UserSlice";

import AuthLayout from "../../Layout/AuthLayout";
import CustomButton from "../../Components/CustomButton";
import CustomInput from "../../Components/CustomInput";
import { useTranslation } from "react-i18next";

import "./style.css";
import VerifyModal from "./VerifyModal";
import { crossIcon } from "../../Assets/svg";
import { Modal } from "react-bootstrap";


const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userPrompts = useSelector((state) => state.user.userPrompts);
  const { t } = useTranslation();

  const [formData, setFormData] = useState({});
  const [loginError, setLoginError] = useState({ error: false, text: "" });
  const [loading, setLoading] = useState(false);
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [showHouseHoldModal, setShowHouseHoldModal] = useState(false);
  // const [showCompleteTermInDaysModal, setShowCompleteTermInDaysModal] = useState(false);

  // Clear Session while doing refresh
  useEffect(() => {
    const clearStorage = () => {
      localStorage.clear();
      sessionStorage.clear();
    };
    window.addEventListener('beforeunload', clearStorage);
    return () => {
      window.removeEventListener('beforeunload', clearStorage);
    };
  }, []);

  const handleClick = async (e) => {
    e.preventDefault();

    if (!formData?.email || formData?.email === "") {
      setLoginError({
        error: true,
        text: userPrompts?.email_required_message || t("auth.login.emailRequired"),
      });
      return
    }

    if (!formData?.password || formData?.password === "") {
      setLoginError({
        error: true,
        text: userPrompts?.password_required_message || t("auth.login.passwordRequired"),
      });
      return
    }

    setLoading(true);
    handleLogin();
    // const response = await axios.get(
    //   `${BASEURL}/api/user/get_user_eligibility_on_login/${formData.email}`,
    // );
    // if (response.data.data?.length > 0) {
    //   const { eligible_for_login, } = response.data.data[0]
    //   const message = response.data.message;
    //   if (!eligible_for_login) {
    //     setLoginError({ error: true, "text": message })
    //     setLoading(false)
    //   } else {
    //     await handleLogin()
    //   }
    // }
  }
  const handleLogin = async (e) => {


    if (formData.password.length >= 6) {
      const formDataToSend = new FormData();
      formDataToSend.append("username", formData.email?.trim());
      formDataToSend.append("password", formData.password);
      formDataToSend.append("login_platform", "web");

      const response = await axios.post(
        `${BASEURL}/api/user/login/`,
        formDataToSend
      );

      if (!response.data.error) {
        localStorage.setItem("user", JSON.stringify(response?.data?.data[0]));
        localStorage.setItem("is_primary", JSON.stringify(response?.data?.data[0]?.is_primary));
        localStorage.setItem("userId", JSON.stringify(response?.data?.data[0]?.id));
        localStorage.setItem("user_country", JSON.stringify(response?.data?.data[0]?.country));
        localStorage.setItem("date_of_birth", JSON.stringify(response?.data?.data[0]?.date_of_birth));
        localStorage.setItem("is_mature", JSON.stringify(response?.data?.data[0]?.is_mature));
        localStorage.setItem("allowextendedmix", JSON.stringify(response?.data?.data[0]?.['allowextendedmix']));
        dispatch(setUserDetails(response.data.data[0]));
        setLoading(false);
        setLoginError({ error: false, text: "" });
        if (response.data.data[0].is_exceed) {
          setShowHouseHoldModal(true)
        } else {
          const { status, subscription_status, user_route, coupon } = response?.data?.data[0];
          // if (status === "lead" || subscription_status === 'ReSubscription_Failed' || subscription_status === 'incomplete') {
          //   if (user_route && user_route != "signup") {
          //     // debugger
          //     window.sessionStorage.setItem("isPromoUser", true);
          //     if (coupon && coupon.hasOwnProperty("id") && coupon?.duration_type === "term_in_days") {
          //       // setShowCompleteTermInDaysModal(true);
          //     } else {
          //       navigate(user_route);
          //     }
          //   } else {
          //     navigate("/subscription");
          //   }
          //   return;
          // }
          //  else if (status === "coupon_lead") {
          //   if (user_route) {
          //     window.sessionStorage.setItem("isPromoUser", true);
          //     if (coupon && coupon.hasOwnProperty("id")  && coupon?.duration_type === "term_in_days") {
          //       setShowCompleteTermInDaysModal(true);
          //     } else {
          //       navigate(user_route);
          //     }
          //     return;
          //   }
          // } 
          if (status === "primary" || status === "coupon" || status === "coupon_sub_user" || status === "sub_user" || status === "coupon_lead" || status === "lead") {
            const token = response.data.data[0].token;
            setAccessToken(token);
            navigate("/home");
          } else {
            setLoginError({
              error: true,
              text: t("auth.login.genericError"),
            });
          }
        }
      } else {
        setLoading(false);
        setLoginError({
          error: true,
          text: response.data.message
        });
        if (!response?.data?.data[0].verify) {
          dispatch(setUserDetails(response?.data?.data[0]));
          setShowVerifyModal(true);
        }
      }

    } else {
      setLoading(false);
      setLoginError({
        error: true,
        text: userPrompts?.password_length_message || t("auth.login.passwordLengthError"),
      });
    }
  };

  return (
    <>
      <AuthLayout pagename="login" login={true}>
        <form>
          <div className="row">
            <div className="col-12">
              <CustomInput
                label={t("auth.login.emailLabel")}
                required
                id="email"
                type="text"
                labelClass="mainLabel"
                inputClass="mainInput"
                onChange={(event) => {
                  setLoginError({
                    error: false,
                    text: ""
                  })
                  setFormData({
                    ...formData,
                    email: event.target.value,
                  });
                }}
              />
            </div>
            <div className="col-12">
              <CustomInput
                label={t("auth.login.passwordLabel")}
                required
                id="pass"
                type="password"
                labelClass="mainLabel"
                inputClass="mainInput"
                onChange={(event) => {
                  setLoginError({
                    error: false,
                    text: ""
                  })
                  setFormData({
                    ...formData,
                    password: event.target.value,
                  });
                }}
              />
            </div>
            {loginError.error == true && (
              <div className="col-12">
                <p className="smallText lightColor w-100 text-wrap">{loginError.text}</p>
              </div>
            )}
            <div className="col-12 text-end">
              <Link to={"/forgot-password"} className={"authFormLinks"}>
                {t("auth.login.forgotPassword")}
              </Link>
            </div>
          </div>

          <div className="row mt-4 text-center">
            <div className="col-12">
              {
                loading ? (

                  <button className="primaryButton customButton">
                    <div className="spinner-border spinner-border-sm text-dark" role="status"></div>
                  </button>
                )
                  : (

                    <CustomButton
                      variant="primaryButton"
                      text={t("auth.login.submit")}
                      onClick={handleClick}
                    />
                  )
              }
            </div>
          </div>
        </form>
      </AuthLayout>

      {showVerifyModal && <VerifyModal />}


      {showHouseHoldModal &&
        <div className="household-modal">
          <div className="household-modal-inner">
            <div className="text-end">
              <button
                className="closeButton notButton ms-auto"
                onClick={() => { setShowHouseHoldModal(false); }}
              >
                <img src={crossIcon} alt="" />
              </button>
            </div>
            <p className="mb-4 lh-16 font-16">{t("auth.householdModal.line1")}</p>
            <p className="mb-4 lh-16 font-16">{t("auth.householdModal.line2")}</p>
            <p className="mb-4 lh-16 font-16">{t("auth.householdModal.option1")}</p>
            <p className="mb-4 lh-16 font-16">
              {t("auth.householdModal.option2")}{" "}
              <Link to={"/subscription"} className="lh-16 font-16">{t("auth.householdModal.cta")}</Link>
            </p>
            <p className="lh-16 font-16">{t("auth.householdModal.footer")}</p>
            <Link to="https://relaxscofa.com/faq/#sub-accounts" className="lh-16 font-16">{t("auth.householdModal.footerLink")}</Link>
          </div>
        </div>
      }

      {/* term in days modal */}
      {/* <Modal
        show={showCompleteTermInDaysModal}
        centered
        className="success-modal blur-modal"
        backdrop="static"
      >
        <Modal.Body>
          <div className="p-5">
            <h2 className="font-16 lh-16 mt-5 fw-normal text-center">Your term in days has been completed.</h2>
            <div className='text-center mt-4'>
              <CustomButton
                variant="primaryButton"
                text="Payment"
                onClick={() => navigate('/promo')}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal> */}


    </>
  );
};

export default Login;
